import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {
    FormControl,
    FormGroup,
    InputGroup,
    ControlLabel,
    Col,
    Row,
    Checkbox
} from 'react-bootstrap';
import axios from 'axios';
import config from '../config';
import SpinnerButton from './SpinnerButton';
import DismissableAlert from './DismissableAlert';
import TimezonePicker from 'react-bootstrap-timezone-picker';
import 'react-bootstrap-timezone-picker/dist/react-bootstrap-timezone-picker.min.css';

import './CreateQuestionForm.css';

class CreateQuestionForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newQuestion: null,
            isLoading: false,
            description: '',
            typeID: 1,
            answer: '',
            organisationUUID: this.props.uuid,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            },
            questionTypes: this.props.questionTypes
        };
    }

    componentDidMount() {}

    componentWillReceiveProps(newProps) {
        this.setState({
            questionTypes: newProps.questionTypes
        });
    }

    validateForm() {
        return this.state.description.length > 0 && this.state.answer.length;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        event.preventDefault();

        this.setState({ isLoading: true });

        try {
            var self = this;
            axios
                .post(`${config.baseURL}/questions`, {
                    description: this.state.description,
                    typeID: this.state.typeID,
                    answer: this.state.answer
                })
                .then(function(response) {
                    self.setState({
                        newQuestion: response.data.question,
                        isLoading: false,
                        error: {
                            hidden: false,
                            title: `${t('CreateQuestionForm.success')}:`,
                            style: 'success',
                            message: `${t(
                                'CreateQuestionForm.created_message'
                            )}`
                        }
                    });
                })
                .catch(function(err) {
                    self.setState({
                        isLoading: false,
                        error: {
                            hidden: false,
                            title: `${t('CreateQuestionForm.error')}:`,
                            style: 'danger',
                            message: err.response.data.message
                        }
                    });
                });
        } catch (e) {
            this.setState({
                isLoading: false,
                error: {
                    hidden: false,
                    title: `${t('CreateQuestionForm.error')}:`,
                    style: 'danger',
                    message: `${t('CreateQuestionForm.unknown_error')}`
                }
            });
        }
    };

    renderForm() {
        const { t } = this.props;

        return (
            <div id="createAttributeForm">
                <form onSubmit={this.handleSubmit}>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <DismissableAlert
                                title={this.state.error.title}
                                message={this.state.error.message}
                                hidden={this.state.error.hidden}
                                style={this.state.error.style}
                            />
                        </Col>
                    </Row>

                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup controlId="typeID" bsSize="sm">
                                <label>{t('CreateQuestionForm.type')}</label>
                                <FormControl
                                    componentClass="select"
                                    placeholder="Choose..."
                                    value={this.state.typeID}
                                    onChange={this.handleChange}
                                >
                                    {this.state.questionTypes.map(
                                        (type, key) => {
                                            console.log(type);
                                            return (
                                                <option
                                                    key={key}
                                                    value={type.id}
                                                >
                                                    {type.description}
                                                </option>
                                            );
                                        }
                                    )}
                                </FormControl>
                                <small className="form-text text-muted">
                                    {t('CreateQuestionForm.required')}
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup controlId="description" bsSize="sm">
                                <ControlLabel>
                                    {t('CreateQuestionForm.description')}
                                </ControlLabel>
                                <FormControl
                                    autoFocus
                                    type="text"
                                    value={this.state.description}
                                    onChange={this.handleChange}
                                />
                                <small className="form-text text-muted">
                                    {t('CreateQuestionForm.required')}
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup controlId="answer" bsSize="sm">
                                <ControlLabel>
                                    {t('CreateQuestionForm.answer')}
                                </ControlLabel>
                                <FormControl
                                    type="text"
                                    value={this.state.answer}
                                    onChange={this.handleChange}
                                />
                                <small className="form-text text-muted">
                                    {t('CreateQuestionForm.required')}
                                </small>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <FormGroup bsSize="sm">
                                <SpinnerButton
                                    block
                                    bsStyle="primary"
                                    disabled={!this.validateForm()}
                                    type="submit"
                                    isLoading={this.state.isLoading}
                                    text={`${t(
                                        'CreateQuestionForm.add_question'
                                    )}`}
                                    loadingText={`${t(
                                        'CreateQuestionForm.adding_question'
                                    )}`}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }

    renderSuccessMessage() {
        return (
            <div id="successMessage">
                <form>
                    <Row bsClass="form-row">
                        <Col sm={12}>
                            <DismissableAlert
                                title={this.state.error.title}
                                message={this.state.error.message}
                                hidden={this.state.error.hidden}
                                style={this.state.error.style}
                            />
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }

    render() {
        return (
            <div className="CreateQuestionForm">
                {this.state.newQuestion === null
                    ? this.renderForm()
                    : this.renderSuccessMessage()}
            </div>
        );
    }
}

export default translate('translations')(CreateQuestionForm);
